import React, { useState, useEffect } from 'react';  // Add useEffect
import { motion } from 'framer-motion';
import { IoAddOutline } from 'react-icons/io5';
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { toast } from 'react-toastify';
import axios from 'axios';
import { useUser } from '../../context/UserContext';  // Add this import
import { useCustomDialog } from '../../context/DialogProvider';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { format } from 'date-fns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api from '../../utils/api';
import { TbClockPlus } from 'react-icons/tb';

const TIME_CONFIG = {
  FULL_DAY: { label: 'Full Day', duration: 1 },
  FIRST_HALF: { label: 'First Half', duration: 0.5 },
  SECOND_HALF: { label: 'Second Half', duration: 0.5 }
};



function E_CompOff() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { currentUser,loading } = useUser();
  const{confirm} = useCustomDialog();
  const [compOffs, setCompOffs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showApplyForm, setShowApplyForm] = useState(false);
  const [newCompOff, setNewCompOff] = useState({
  onDate: '',
  duration: TIME_CONFIG.FULL_DAY.duration,
  reason: '',
  timing: 'FULL_DAY' // Must match key used in TIME_CONFIG
});

  const [isEditing, setIsEditing] = useState(false); // Add a new state to track if we're editing
  const [isSubmitting, setIsSubmitting] = useState(false); // Add this with other state declarations
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewCompOff, setViewCompOff] = useState(null);
  const compOffsPerPage = 6;
  const[editingCompOffId,setEditingCompOffId] = useState(null);
    const [holidays,setHolidays]=useState([])

  // Pagination logic
  const totalPages = Math.ceil(compOffs.length / compOffsPerPage);
  const paginatedCompOffs = compOffs.slice(
    (currentPage - 1) * compOffsPerPage,
    currentPage * compOffsPerPage
  );

  const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = (`0${date.getMonth() + 1}`).slice(-2); // months are 0-indexed
  const day = (`0${date.getDate()}`).slice(-2);
  return `${year}-${month}-${day}`;
};

  const isWeekdayAndNotHoliday = (date, holidays = []) => {
  if (!date || !Array.isArray(holidays)) return true;

  const day = date.getDay(); // 0 = Sunday, 6 = Saturday
  const isWeekend = day === 0 || day === 6;

  const formatted = formatLocalDate(date); // 👈 Use local time

  const isHoliday = holidays.some(holiday => holiday.holidayDate === formatted);

  return !isWeekend && !isHoliday;
};

  const fetchHolidays = async () => {
    
    try {
      const response = await api.get(`/api/holidays`);
      setHolidays(response.data);
      console.log(response.data)
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
};

useEffect(() => {
    fetchHolidays();
}, []);

  // Add fetch function
  const fetchCompOffs = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(`/api/compoffs/${currentUser?.id}`);
      setCompOffs(response.data);
    } catch (error) {
      console.error('Error fetching comp offs:', error);
      toast.error('Failed to fetch comp off requests');
    } finally {
      setIsLoading(false);
    }
  };

  // Add useEffect to fetch data on component mount
  useEffect(() => {
    if(!loading){
   fetchCompOffs();
    }
    
  }, [currentUser?.id]);

  const handleDelete = async (id) => {
     const confirmed = await confirm("Are you sure you want to delete this comp off request?");
    
      try {
        if (confirmed) {
        await api.delete(`/api/compoffs/${id}`, {
          params: { employeeId: currentUser?.id }
        });
      }
        fetchCompOffs();  // Refresh the list
        toast.success('Comp off request deleted successfully');
      } catch (error) {
        console.error('Error deleting comp off:', error);
        toast.error('Failed to delete comp off request');
      }
    
  };

  const handleEdit = (compOff) => {

    setEditingCompOffId(compOff.id);
    setNewCompOff({
      onDate: compOff.onDate,
      reason: compOff.reason,
      timing:compOff.timing
    });
    setIsEditing(true);
    setShowApplyForm(true);
  };

  const handleView = (compOff) => {
    setViewCompOff(compOff);
    setShowViewModal(true);
  };

  const formatDateForBackend = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const payload = {
    ...newCompOff,
    onDate: formatDateForBackend(newCompOff.onDate),
    employeeId: currentUser?.id
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      if (isEditing) {
        await api.put(`/api/compoffs/${editingCompOffId}?employeeId=${currentUser?.id}`, payload);
        console.log("Submitting new comp off:", newCompOff);
        console.log("off id:",editingCompOffId);
        toast.success('Comp off request updated successfully');
      } else {
        await api.post(`/api/compoffs/apply?employeeId=${currentUser?.id}`, payload);
        
        toast.success('Comp off request submitted successfully');
      }
      fetchCompOffs();
      setShowApplyForm(false);
      setIsEditing(false);
      setNewCompOff({ onDate: '', reason: '',duration: TIME_CONFIG.FULL_DAY.duration,timing: 'FULL_DAY' });
    } catch (error) {
      console.error('Error submitting comp off:', error);
      toast.error(isEditing ? 'Failed to update comp off request '+{error} : 'Failed to submit comp off request '+{error});
    } finally {
      setIsSubmitting(false);
    }
  };


  // Keep the main structure and only show loading in table rows
  return (
    <div className="sm:p-6 sm:mt-auto mt-8 am:mb-auto mb-20 w-full mx-auto">
      <motion.div 
        className="flex justify-between items-center mb-6 bg-indigo-100 rounded-2xl p-6 border border-indigo-200"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="flex items-center gap-4 text-xl xs:text-2xl  font-bold truncate"  >
        <div className="p-2 rounded-lg bg-slate-800 text-indigo-100" ><TbClockPlus/></div>
        <h2 className="text-xl xs:text-2xl font-bold">My Comp Offs</h2>
        </div>
        <motion.button
          onClick={() => setShowApplyForm(true)}
          className="bg-slate-800 text-white px-4 py-2 rounded-full hover:bg-slate-700 flex items-center gap-2"
        >
          <IoAddOutline className="text-lg" />
          <span>Add</span>
        </motion.button>
      </motion.div>

      {/* Desktop View */}
      <motion.div
        className="hidden sm:block bg-white rounded-2xl border border-slate-200 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-white">
              <tr>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">SL No</th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">Comp Off Date</th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">Session</th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">Status</th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">Expires on</th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {isLoading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-8 text-center">
                    <div className="flex justify-center items-center">
                      <svg
                        className="animate-spin h-8 w-8 text-slate-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8z"
                        ></path>
                      </svg>
                    </div>
                  </td>
                </tr>
              ) : (
                paginatedCompOffs.length > 0 ? (
                  paginatedCompOffs.map((compOff, index) => (
                    <tr key={compOff.id} className="hover:bg-slate-50/50 transition-colors duration-150">
                      <td className="px-6 py-4 text-slate-600">
                        {(currentPage - 1) * compOffsPerPage + index + 1}
                      </td>
                      <td className="px-6 py-4 text-slate-600">{format(new Date(compOff.onDate), "dd-MM-yyyy")}</td>
                      <td className="px-6 py-4 text-slate-600">{compOff.timing==="FULL_DAY" ? "Full day":compOff.timing==="FIRST_HALF"? "First half":"Second half"}</td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                          compOff.comOffStatus === "APPROVED" 
                            ? "bg-green-100 text-green-800"
                            : compOff.comOffStatus === "PENDING"
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-red-100 text-red-800"
                        }`}>
                          {compOff.comOffStatus==="APPROVED" ? "Approved":compOff.comOffStatus==="PENDING" ? "Pending":"Rejected"}
                        </span>
                      </td>
                      <td className="px-6 py-4">
  {compOff.comOffStatus === "APPROVED" && compOff.expiresOn
    ? format(new Date(compOff.expiresOn), "dd-MM-yyyy")
    : "-"}
</td>
                      <td className="px-6 py-4">
                        <div className="flex justify-center gap-3">
                          {compOff.comOffStatus === "PENDING" ? (
                            <>
                              <motion.button
                                onClick={() => handleEdit(compOff)}
                                className="text-yellow-600 hover:text-yellow-800 transition-colors"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                title="Edit"
                              >
                                <FaRegEdit className="text-xl" />
                              </motion.button>
                              <motion.button
                                onClick={() => handleDelete(compOff.id)}
                                className="text-red-600 hover:text-red-800 transition-colors"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                title="Delete"
                              >
                                <MdOutlineDelete className="text-xl" />
                              </motion.button>
                            </>
                          ) : (
                            <motion.button
                              onClick={() => handleView(compOff)}
                              className="text-blue-600 hover:text-blue-800 transition-colors"
                              whileHover={{ scale: 1.1 }}
                              whileTap={{ scale: 0.9 }}
                              title="View"
                            >
                              {/* Use the same SVG as E_Leave for the view icon */}
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                            </motion.button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="px-6 py-8 text-center text-slate-400">
                      No comp off requests found
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-slate-100">
          <Stack spacing={2} className="flex justify-end">
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(_, page) => setCurrentPage(page)}
              variant="outlined"
              shape="rounded-full"
              size="large"
              showFirstButton
              showLastButton
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "#475569",
                  borderColor: "#e2e8f0",
                },
                "& .Mui-selected": {
                  backgroundColor: "#475569 !important",
                  color: "#fff",
                },
              }}
            />
          </Stack>
        </div>
      </motion.div>

      {/* Mobile View */}
      <div className="sm:hidden space-y-4">
        {isLoading ? (
          <div className="bg-white p-5 rounded-xl shadow-md border border-slate-100">
            <div className="flex justify-center items-center py-8">
              <svg
                className="animate-spin h-8 w-8 text-slate-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
            </div>
          </div>
        ) : (
          paginatedCompOffs.length > 0 ? (
            paginatedCompOffs.map((compOff, index) => (
              <div
                key={compOff.id}
                className="bg-white p-5 rounded-xl shadow-md border border-slate-100"
              >
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <h3 className="font-semibold text-slate-800">Request #{index + 1}</h3>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      compOff.comOffStatus === "APPROVED" 
                        ? "bg-green-100 text-green-800"
                        : compOff.comOffStatus === "PENDING"
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-red-100 text-red-800"
                    }`}>
                      {compOff.comOffStatus}
                    </span>
                  </div>
                  <div className="space-y-2">
                    <div className="flex justify-between text-sm">
                      <span className="text-slate-500">Comp Off Date:</span>
                      <span className="text-slate-700">{compOff.onDate}</span>
                    </div>
                    <div className="flex flex-col gap-1 text-sm">
                      <span className="text-slate-500">Reason:</span>
                      <span className="text-slate-700">{compOff.reason}</span>
                    </div>
                  </div>
                </div>
              </div>
            )) 
          ) : (
            <div className="bg-white p-8 rounded-xl text-center text-slate-400">
              No comp off requests found
            </div>
          )
        )}
        <div className="mt-6 flex justify-center">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(_, page) => setCurrentPage(page)}
              variant="outlined"
              shape="rounded-full"
              size="medium"
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "#475569",
                  borderColor: "#e2e8f0",
                },
                "& .Mui-selected": {
                  backgroundColor: "#475569 !important",
                  color: "#fff",
                },
              }}
            />
          </Stack>
        </div>
      </div>

      {/* View Modal */}
      {showViewModal && viewCompOff && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowViewModal(false)}
        >
          <motion.div 
            className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full mx-4"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            onClick={e => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-slate-800">Comp Off Details</h3>
              <button
                onClick={() => setShowViewModal(false)}
                className="text-slate-400 hover:text-slate-600"
              >
                ✕
              </button>
            </div>
            {/* View Modal Content */}
            <div className="space-y-4">
              <div>
                <p className="text-sm text-slate-500">Comp Off Date</p>
                <div className="flex justify-between items-center">
                  <p className="font-medium text-slate-800">{viewCompOff.onDate}</p>
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                    viewCompOff.comOffStatus === "APPROVED" 
                      ? "bg-green-100 text-green-800"
                      : viewCompOff.comOffStatus === "PENDING"
                      ? "bg-yellow-100 text-yellow-800"
                      : "bg-red-100 text-red-800"
                  }`}>
                    {viewCompOff.comOffStatus}
                  </span>
                </div>
              </div>
              <div>
                <p className="text-sm text-slate-500">Reason</p>
                <p className="font-medium text-slate-800">{viewCompOff.reason}</p>
              </div>
              {viewCompOff.comOffStatus === "REJECTED" && viewCompOff.approverComment && (
                <div>
                  <p className="text-sm text-slate-500">Rejection Reason</p>
                  <p className="font-medium text-slate-800">{viewCompOff.approverComment}</p>
                </div>
              )}
              {/* Add close button at bottom */}
              <div className="flex justify-center pt-4">
                <button
                  onClick={() => setShowViewModal(false)}
                  className="w-full px-4 py-2 text-sm font-medium text-slate-50 hover:text-slate-800 rounded-full bg-slate-600 hover:bg-slate-400"
                >
                  Close
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}

      {/* Apply Form Modal */}
      {showApplyForm && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
          onClick={(e) => {
            // Only close if not submitting and clicked outside modal
            if (!isSubmitting && e.target === e.currentTarget) {
              setShowApplyForm(false);
              setIsEditing(false);
              setNewCompOff({ onDate: '', reason: '',duration: TIME_CONFIG.FULL_DAY.duration,timing: 'FULL_DAY' });
            }
          }}
        >
          <motion.div 
            className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full mx-4"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            onClick={e => e.stopPropagation()} // Prevent closing when clicking modal content
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-slate-800">
                {isEditing ? 'Edit Comp Off' : 'Add Comp Off'}
              </h3>
              <button
                onClick={() => {
                  // Only allow closing if not submitting
                  if (!isSubmitting) {
                    setShowApplyForm(false);
                    setIsEditing(false);
                    setNewCompOff({ onDate: '', reason: '',duration: TIME_CONFIG.FULL_DAY.duration,timing: 'FULL_DAY' });
                  }
                }}
                disabled={isSubmitting}
                className={`text-slate-400 hover:text-slate-600 ${
                  isSubmitting ? 'cursor-not-allowed opacity-50' : ''
                }`}
              >
                ✕
              </button>
            </div>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Comp Off Date</label>
                <DatePicker
  selected={newCompOff.onDate}
  onChange={(date) => setNewCompOff({...newCompOff, onDate: date})}
  dateFormat="dd-MM-yyyy"
  placeholderText="📅 Select date"
  filterDate={(date) => !isWeekdayAndNotHoliday(date, holidays)}
  required
   disabled={isEditing}
 className="w-full border border-slate-200 rounded-lg p-2.5 pl-10 focus:outline-none focus:border-slate-500"
/>
              </div>
               <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Timing</label>
          <select
  value={newCompOff.timing}
  onChange={(e) => {
    const selectedKey = e.target.value;
    const config = TIME_CONFIG[selectedKey];
    setNewCompOff({
      ...newCompOff,
      duration: config.duration,
      timing: selectedKey
    });
  }}
  className="w-full border border-slate-200 rounded-lg p-3"
  required
>
  {Object.entries(TIME_CONFIG).map(([key, config]) => (
    <option key={key} value={key}>{config.label}</option>
  ))}
</select>
        </div>
        </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Reason</label>
                <textarea
                  value={newCompOff.reason}
                  onChange={(e) => setNewCompOff({...newCompOff, reason: e.target.value})}
                  className="w-full border border-slate-200 rounded-lg p-2.5"
                  rows="3"
                  required
                ></textarea>
              </div>
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowApplyForm(false);
                    setIsEditing(false);
                    setNewCompOff({ onDate: '', reason: '',duration: TIME_CONFIG.FULL_DAY.duration,timing: 'FULL_DAY' });
                  }}
                  className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-4 py-2 text-sm font-medium bg-slate-800 text-white rounded-full hover:bg-slate-700 
                              disabled:bg-slate-400 disabled:cursor-not-allowed flex items-center justify-center min-w-[100px]`}
                  >
                  {isSubmitting ? (
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      <span>{isEditing ? 'Updating...' : 'Submitting...'}</span>
                    </div>
                  ) : (
                    <span>{isEditing ? 'Update' : 'Submit'}</span>
                  )}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
    </div>
  );
}

export default E_CompOff;